import { jsx as _jsx } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import { EnumerableTextElements } from '@common/text-formattings/enumerable-text-elements';
export function UsersTableGroups({ groups }) {
    return (_jsx(EnumerableTextElements, { getKey: group => `user-group-${group.id}`, getValue: group => _jsx(Text, { children: group.name }), items: groups, maxVisibleElems: 2 }));
}
